// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RNSlt","colBig":"styles_colBig__1llTI","colSmall":"styles_colSmall__34VsT"};